// extracted by mini-css-extract-plugin
export var main = "wall-paintings-module--main--BAkkp";
export var preview = "wall-paintings-module--preview--lE2+B";
export var previewImage = "wall-paintings-module--preview-image--MdQyP";
export var wallPaintingContact = "wall-paintings-module--wall-painting-contact--4lBGs";